import { MenuItem, TextField } from "@mui/material";
import { Box } from "@mui/system";
import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { SyncLoader } from "react-spinners";
import { toast, ToastContainer, Zoom } from "react-toastify";
import { handleAddClose } from "../../../redux/Reducer/ModalSlice";
import { ThemButton } from "../../Login/Login.style";
import { ErrorMessage } from "../../Volunteer/Volunteer.style";
import "react-toastify/dist/ReactToastify.css";
const AddStudy = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState();

  const { data: sponsorInfo = [],refetch } = useQuery({
    queryKey: ["sponsorInfo"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/sponsorDropdown`
      );
      const data = await res.json();
      return data;
    },
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
  } = useForm();

  const onSubmit = (data, e) => {
    // alert(JSON.stringify(data));
    setIsLoading(true);
    const formData = new FormData();
    formData.append("sponsor_id", data.sponsor_id);
    formData.append("study_code", data.study_code);
    formData.append("protocol_title", data.protocol_title);
    fetch(
      `${process.env.REACT_APP_API_URL}/api/createStudy`,
      {
        method: "POST",
        body: formData,
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.success === true) {
          toast.success("Study Add successful", {
            position: toast.POSITION.TOP_CENTER
          });
          refetch().then(() => {
            dispatch(handleAddClose());
          });
        } else if (data.duplicate === true) {
          toast.error("This Study is already exists!!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box p="20px">
        <Controller
          name="sponsor_id"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TextField
              {...field}
              select
              fullWidth
              size="small"
              label="Sponsor Name*"
            >
              {sponsorInfo.map((sponsor) => (
                <MenuItem key={Math.random()} value={sponsor.sponsor_id}>
                  {sponsor.sponsor_name}
                </MenuItem>
              ))}
            </TextField>
          )}
          rules={{ required: true }}
        />
        {errors?.sponsor_id?.type === "required" && (
          <ErrorMessage>Sponsor Name is required</ErrorMessage>
        )}
      </Box>

      <Box p=" 0 20px 20px 20px">
        <TextField
          size="small"
          fullWidth
          label="Study Code*"
          variant="outlined"
          {...register("study_code", { required: true })}
        />
        {errors?.study_code?.type === "required" && (
          <ErrorMessage>Study Code is required*</ErrorMessage>
        )}
      </Box>

      <Box p=" 0 20px 20px 20px">
        <TextField
          size="small"
          fullWidth
          label="Protocol Title*"
          variant="outlined"
          {...register("protocol_title", { required: true })}
        />
        {errors?.protocol_title?.type === "required" && (
          <ErrorMessage>Protocol is required*</ErrorMessage>
        )}
      </Box>
      <Box sx={{ mb: "15px", display: "flex", justifyContent: "center" }}>
        {isLoading ? (
          <ThemButton style={{}} type="submit">
            <SyncLoader color="#FFFFFF" size={8} />
          </ThemButton>
        ) : (
          <ThemButton style={{}} type="submit">
            Add Study
          </ThemButton>
        )}

        <ToastContainer
          autoClose={2000}
          limit={1}
          transition={Zoom}
          toastStyle={{ border: "2px solid crimson" }}
        />
      </Box>
    </form>
  );
};

export default AddStudy;
